import { errorHandler } from '@gtpl/shared-utils/error-messages';
import { Body, Controller, Get, Param, Post, Query, Req, Res, UploadedFiles, UseInterceptors } from '@nestjs/common';
import { FileFieldsInterceptor } from '@nestjs/platform-express';
import { ApiConsumes, ApiOperation, ApiParam, ApiTags } from '@nestjs/swagger';
import { WardsResponseModel } from './dto/wards-response.model';
import { WardsDto } from './dto/wards.dto';
import { WardsService } from './wards.service';

@ApiTags('Wards')
@Controller('wards')
export class WardsController {
    constructor (
        private wardService: WardsService
    ) {}

   
    @Post('/save')   
    async create(@Body() sDTO:WardsDto, @Req() request: Request): Promise<WardsResponseModel> {
        try {
            return await this.wardService.createNew(sDTO, request);
        } catch (error) {
            return errorHandler(WardsResponseModel, error);
        }
    }

    @Post('/update')
    async update(@Body() sDTO:WardsDto, @Req() request: Request): Promise<WardsResponseModel> {
        try {
            return await this.wardService.updateOld(sDTO, request);
        } catch (error) {
            return errorHandler(WardsResponseModel, error);
        }
    }


    @Get('/getAll')
    async getdata(@Req() request:Request):Promise<WardsResponseModel> {
        try {
            return await this.wardService.getdata();
        } catch (error) {
            return errorHandler(WardsResponseModel, error);
        }
    }
}


